import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import type { AcknowledgmentBlockedAction } from 'partner360/features/acknowledgmentStatusDialog'
import { getTranslatedText } from 'partner360/helpers/getTranslatedText'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../configs/translations'
import { useNextIncompleteOffering } from '../../../model/hooks/useNextIncompleteOffering'

/**
 * The acknowledgment window's way out of a plan the server holds: `Open {Offering}` to the next
 * incomplete offering of the cockpit. `onBeforeOpen` lets the host close its window first.
 */
export const useNextOfferingBlockedAction = (
  offering: string | null,
  onBeforeOpen?: () => void
): AcknowledgmentBlockedAction | null => {
  const t = useSafetyTranslation()
  const next = useNextIncompleteOffering(offering)

  return useMemo(() => {
    if (!next) {
      return null
    }

    return {
      label: (
        <Translation
          span
          text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.attentionStatuses.nextSteps.openOffering}
          replaceParams={[
            { key: '{Offering}', value: getTranslatedText({ t, key: next.titleKey }) },
          ]}
        />
      ),
      onClick: () => {
        onBeforeOpen?.()
        next.open()
      },
    }
  }, [next, onBeforeOpen, t])
}
